import { render, staticRenderFns } from "./MandateOverview.vue?vue&type=template&id=436f7a3a&scoped=true&"
import script from "./MandateOverview.vue?vue&type=script&lang=ts&"
export * from "./MandateOverview.vue?vue&type=script&lang=ts&"
import style0 from "./MandateOverview.vue?vue&type=style&index=0&id=436f7a3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436f7a3a",
  null
  
)

export default component.exports